import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Link from '../../../Link';

export function EmbedInfo({
  headline,
  headlineUrl,
  dek,
  isBreaking,
  label,
  showLabel,
  isNotRail,
  isStacked,
}) {
  const ConditionalLink = ({ condition, wrapper, children }) => {
    if (condition) {
      return wrapper(children);
    }
    return children;
  };

  if (!headline && !dek) {
    return null;
  }

  const headerClass = classNames(
    'embed-info__headline',
    {
      'embed-info__headline--large-text': isNotRail && !isStacked,
      'embed-info__headline--dekless': !dek,
    },
  );
  const labelClass = classNames(
    'embed-info__label', {
      'embed-info__label--breaking': isBreaking,
      'embed-info__label--large-text': isNotRail && !isStacked,
    },
  );
  const headlineUrlIconClass = classNames(
    'embed-info__headline__icon',
    'icon',
    'icon-arrow-link',
  );

  return (
    <>
      { headline && (
        <ConditionalLink
          condition={headlineUrl}
          wrapper={(children) => <Link href={headlineUrl} data-test="embed-info__link" className="embed-info__link">{children}</Link>}
        >
          <h4
            className={headerClass}
            data-test="embed-info__headline"
          >
            {showLabel && (
              <span
                data-test="embed-info__label"
                className={labelClass}
              >
                {`${label} / `}
              </span>
            )}
            {headline}
            {headlineUrl && (
              <>
                &nbsp;
                <span className={headlineUrlIconClass} />
              </>
            )}
          </h4>
        </ConditionalLink>
      )}
      {dek && (
        <p className="embed-info__dek" data-test="embed-info__dek">
          {dek}
        </p>
      )}
    </>
  );
}

EmbedInfo.propTypes = {
  headline: PropTypes.string,
  headlineUrl: PropTypes.string,
  dek: PropTypes.string,
  isBreaking: PropTypes.bool,
  label: PropTypes.string,
  showLabel: PropTypes.bool,
  isNotRail: PropTypes.bool,
  isStacked: PropTypes.bool,
};

EmbedInfo.defaultProps = {
  headline: null,
  headlineUrl: null,
  dek: null,
  isBreaking: false,
  label: 'Live Updates',
  showLabel: true,
  isNotRail: true,
  isStacked: false,
};
